const testimonials = [
  {
    name: '阿澈',
    role: '追更 5 年 · 收藏 38 部',
    avatar: 'https://readdy.ai/api/search-image?query=flat%20illustration%20avatar%20of%20a%20friendly%20young%20man%20with%20glasses%20and%20short%20hair%2C%20warm%20orange%20and%20cream%20palette%2C%20minimalist%20style%2C%20soft%20round%20face&width=160&height=160&seq=avatar-1&orientation=squarish',
    text: '追了五年的老漫，以前老忘记追更，自从用了我爱漫画网的更新提醒，一话都没漏过。追漫日历把每天的连载安排得清清楚楚，太省心了。',
  },
  {
    name: '桃子不甜',
    role: '轻小说党 · 收藏 22 部',
    avatar: 'https://readdy.ai/api/search-image?query=flat%20illustration%20avatar%20of%20a%20cheerful%20young%20woman%20with%20twin%20braids%20and%20a%20smile%2C%20teal%20and%20cream%20palette%2C%20minimalist%20style%2C%20soft%20round%20face&width=160&height=160&seq=avatar-2&orientation=squarish',
    text: '最爱的就是「养肥再看」功能，几部连载攒一起存着，进度自动保存。跨手机和电脑同步也没问题，出差换设备照样接上。',
  },
  {
    name: '老白',
    role: '推理控 · 收藏 15 部',
    avatar: 'https://readdy.ai/api/search-image?query=flat%20illustration%20avatar%20of%20a%20calm%20middle-aged%20man%20with%20short%20beard%2C%20amber%20and%20cream%20palette%2C%20minimalist%20style%2C%20soft%20round%20face&width=160&height=160&seq=avatar-3&orientation=squarish',
    text: '悬疑漫追起来最怕断更，更新提醒+追漫日历双保险，哪部哪天更新一眼就知道。收藏清单整理得也舒服，回购率满分。',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold tracking-wide text-secondary-800">用户口碑</span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">漫画迷们的真实评价</h2>
          <p className="mt-4 text-foreground-600">来自不同年龄、不同爱好的追更用户的真实声音。</p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-6"
            >
              <div className="flex text-secondary-500">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-background-100 pt-4">
                <img src={t.avatar} alt={`${t.name} 头像`} className="h-10 w-10 rounded-full object-cover" />
                <div>
                  <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}